import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-school-information-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ModalHeaderComponent
  ],
  templateUrl: './school-information-form.component.html',
  styleUrl: './school-information-form.component.scss'
})
export class SchoolInformationFormComponent implements OnInit {
  @Input() itemId: string = '';
  @Input() modalInstance: any = null;
  @Input() reload: boolean = false;
  modalTitle: string = 'School aanmaken';
  modalStyle: boolean = false;

  regions = [
    'Noord',
    'Midden',
    'Zuid'
  ];

  item: any = {};
  errorMessage: any = {};
  errors: any = {};
  loading: boolean = false;

  constructor(
    private apiService: ApiService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.getItem();
  }

  save() {
    let self = this;

    self.reset();
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if (!this.item['id']) {
      return this.apiService.post('/office/organisations', this.item).then(function (response: any) {
        self.handleSucces(response);
        self.router.navigate(['school/details/' + response.id]);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
    else {
      return this.apiService.put('/office/organisations/' + this.item['id'], this.item).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
  }

  handleSucces(response: any) {
    let self = this;
    self.item = response;
    setTimeout(function () {
      self.loading = false;
      self.modalInstance.close(true);
    }, 200);
  }

  handleError(response: any) {
    let self = this;
    self.errors = response['error']['error'];
    self.errorMessage = response['error']['message'];
    self.loading = false;

    if (response.status == 500) {
      self.errorMessage = response['error']['message'];
      self.errors = [];
    }
  }

  reset() {
    this.errors = {};
    this.errorMessage = '';
  }

  getItem() {
    let self = this;

    self.reset();
    if (this.item.id == null) {
      return;
    } else {
      self.modalTitle = "School wijzigen";
    }

    return this.apiService.get('/office/organisations/' + this.item.id).then(function (response: any) {
      self.item = response;
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
